import { Routes } from '@angular/router';

export const productRoutes: Routes = [
  // Brand
  {
    path: 'brand',
    data: { moduleCode: 'prd_brand' },
    children: [
      { path: '', loadComponent: () => import('./brand/brand').then((m) => m.Brand) },
      { path: 'add', loadComponent: () => import('./brand/brand-details/brand-details').then((m) => m.BrandDetails) },
      { path: 'details/:id', loadComponent: () => import('./brand/brand-details/brand-details').then((m) => m.BrandDetails) },
      { path: 'import', loadComponent: () => import('./brand/brand-import/brand-import').then((m) => m.BrandImport) }
    ]
  },
  {
    path: 'group',
    data: { moduleCode: 'prd_group' },
    children: [
      { path: '', loadComponent: () => import('./group/group').then((m) => m.ProdGroup) },
      { path: 'add', loadComponent: () => import('./group/group-details/group-details').then((m) => m.GroupDetails) },
      { path: 'details/:id', loadComponent: () => import('./group/group-details/group-details').then((m) => m.GroupDetails) },
      { path: 'import', loadComponent: () => import('./group/group-import/group-import').then((m) => m.GroupImport) }
    ]
  },
  {
    path: 'department',
    data: { moduleCode: 'prd_dept' },
    children: [
      { path: '', loadComponent: () => import('./department/department').then((m) => m.Department) },
      { path: 'add', loadComponent: () => import('./department/department-details/department-details').then((m) => m.DepartmentDetails) },
      {
        path: 'details/:id',
        loadComponent: () => import('./department/department-details/department-details').then((m) => m.DepartmentDetails)
      },
      { path: 'import', loadComponent: () => import('./department/department-import/department-import').then((m) => m.DepartmentImport) }
    ]
  },
  {
    path: 'ranking',
    data: { moduleCode: 'prd_ranking' },
    children: [
      { path: '', loadComponent: () => import('./ranking/ranking').then((m) => m.Ranking) },
      { path: 'add', loadComponent: () => import('./ranking/ranking-details/ranking-details').then((m) => m.RankingDetails) },
      { path: 'details/:id', loadComponent: () => import('./ranking/ranking-details/ranking-details').then((m) => m.RankingDetails) },
      { path: 'import', loadComponent: () => import('./ranking/ranking-import/ranking-import').then((m) => m.RankingImport) }
    ]
  },
  {
    path: 'uom',
    data: { moduleCode: 'prd_uom' },
    children: [
      { path: '', loadComponent: () => import('./uom/uom').then((m) => m.Uom) },
      { path: 'add', loadComponent: () => import('./uom/uom-details/uom-details').then((m) => m.UomDetails) },
      { path: 'details/:id', loadComponent: () => import('./uom/uom-details/uom-details').then((m) => m.UomDetails) },
      { path: 'import', loadComponent: () => import('./uom/uom-import/uom-import').then((m) => m.UomImport) }
    ]
  },
  {
    path: 'conversion-rate',
    data: { moduleCode: 'prd_conversion_rate' },
    children: [
      { path: '', loadComponent: () => import('./conversion-rate/conversion-rate').then((m) => m.ConversionRate) },
      {
        path: 'add',
        loadComponent: () =>
          import('./conversion-rate/conversion-rate-details/conversion-rate-details').then((m) => m.ConversionRateDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./conversion-rate/conversion-rate-details/conversion-rate-details').then((m) => m.ConversionRateDetails)
      },
      {
        path: 'import',
        loadComponent: () => import('./conversion-rate/conversion-rate-import/conversion-rate-import').then((m) => m.ConversionRateImport)
      }
    ]
  },
  {
    path: 'tagging',
    data: { moduleCode: 'prd_tagging' },
    children: [
      { path: '', loadComponent: () => import('./tagging/tagging').then((m) => m.Tagging) },
      { path: 'add', loadComponent: () => import('./tagging/tagging-details/tagging-details').then((m) => m.TaggingDetails) },
      { path: 'details/:id', loadComponent: () => import('./tagging/tagging-details/tagging-details').then((m) => m.TaggingDetails) },
      { path: 'import', loadComponent: () => import('./tagging/tagging-import/tagging-import').then((m) => m.TaggingImport) }
    ]
  },
  {
    path: 'cost-type',
    data: { moduleCode: 'prd_cost_type' },
    children: [
      { path: '', loadComponent: () => import('./cost-type/cost-type').then((m) => m.CostType) },
      { path: 'add', loadComponent: () => import('./cost-type/cost-type-details/cost-type-details').then((m) => m.CostTypeDetails) },
      {
        path: 'details/:id',
        loadComponent: () => import('./cost-type/cost-type-details/cost-type-details').then((m) => m.CostTypeDetails)
      },
      { path: 'import', loadComponent: () => import('./cost-type/cost-type-import/cost-type-import').then((m) => m.CostTypeImport) }
    ]
  },
  {
    path: 'product-era',
    data: { moduleCode: 'prd_era' },
    children: [
      { path: '', loadComponent: () => import('./product-era/product-era').then((m) => m.ProductEra) },
      {
        path: 'add',
        loadComponent: () => import('./product-era/product-era-details/product-era-details').then((m) => m.ProductEraDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./product-era/product-era-details/product-era-details').then((m) => m.ProductEraDetails)
      },
      { path: 'import', loadComponent: () => import('./product-era/product-era-import/product-era-import').then((m) => m.ProductEraImport) }
    ]
  },
  {
    path: 'dangerous-goods',
    data: { moduleCode: 'prd_dangerous_goods' },
    children: [
      { path: '', loadComponent: () => import('./dangerous-goods/dangerous-goods').then((m) => m.DangerousGoods) },
      {
        path: 'add',
        loadComponent: () =>
          import('./dangerous-goods/dangerous-goods-details/dangerous-goods-details').then((m) => m.DangerousGoodsDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./dangerous-goods/dangerous-goods-details/dangerous-goods-details').then((m) => m.DangerousGoodsDetails)
      },
      {
        path: 'import',
        loadComponent: () => import('./dangerous-goods/dangerous-goods-import/dangerous-goods-import').then((m) => m.DangerousGoodsImport)
      }
    ]
  },
  {
    path: 'costing-type',
    data: { moduleCode: 'prd_costing_type' },
    children: [
      { path: '', loadComponent: () => import('./costing-type/costing-type').then((m) => m.CostingType) },
      {
        path: 'details/:id',
        loadComponent: () => import('./costing-type/costing-type-details/costing-type-details').then((m) => m.CostingTypeDetails)
      }
    ]
  },
  {
    path: 'barcode-type',
    data: { moduleCode: 'prd_barcode_type' },
    children: [
      { path: '', loadComponent: () => import('./barcode-type/barcode-type').then((m) => m.BarcodeType) },
      {
        path: 'details/:id',
        loadComponent: () => import('./barcode-type/barcode-type-details/barcode-type-details').then((m) => m.BarcodeTypeDetails)
      }
    ]
  },
  {
    path: 'attribute',
    data: { moduleCode: 'prd_attr' },
    children: [
      { path: '', loadComponent: () => import('./attribute/attribute').then((m) => m.Attribute) },
      { path: 'add', loadComponent: () => import('./attribute/attribute-details/attribute-details').then((m) => m.AttributeDetails) },
      {
        path: 'details/:id',
        loadComponent: () => import('./attribute/attribute-details/attribute-details').then((m) => m.AttributeDetails)
      },
      { path: 'import', loadComponent: () => import('./attribute/attribute-import/attribute-import').then((m) => m.AttributeImport) }
    ]
  },
  {
    path: 'category',
    data: { moduleCode: 'prd_category' },
    children: [
      { path: '', loadComponent: () => import('./category/category').then((m) => m.Category) },
      { path: 'add', loadComponent: () => import('./category/category-details/category-details').then((m) => m.CategoryDetails) },
      { path: 'details/:id', loadComponent: () => import('./category/category-details/category-details').then((m) => m.CategoryDetails) },
      { path: 'import', loadComponent: () => import('./category/category-import/category-import').then((m) => m.CategoryImport) }
    ]
  },
  {
    path: 'price-level',
    data: { moduleCode: 'prd_price_level' },
    children: [
      { path: '', loadComponent: () => import('./price-level/price-level').then((m) => m.PriceLevel) },
      {
        path: 'add',
        loadComponent: () => import('./price-level/price-level-details/price-level-details').then((m) => m.PriceLevelDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./price-level/price-level-details/price-level-details').then((m) => m.PriceLevelDetails)
      },
      { path: 'import', loadComponent: () => import('./price-level/price-level-import/price-level-import').then((m) => m.PriceLevelImport) }
    ]
  },
  // Price Change
  {
    path: 'price-change',
    data: { moduleCode: 'prd_price_change' },
    children: [
      { path: '', loadComponent: () => import('./new-price-change-req/new-price-change-req').then((m) => m.NewPriceChangeReq) },
      { path: 'details/:id', loadComponent: () => import('./price-change-profile/details/details').then((m) => m.PriceChangeProfileDetails), data: { reqModuleType: 'approver' } }
    ]
  },
  // Cost Change
  {
    path: 'cost-change',
    data: { moduleCode: 'prd_cost_change' },
    children: [
      { path: '', loadComponent: () => import('./new-cost-change-req/new-cost-change-req').then((m) => m.NewCostChangeReq) },
      { path: 'details/:id', loadComponent: () => import('./cost-change-profile/cost-change-details/cost-change-details').then((m) => m.CostChangeDetails), data: { reqModuleType: 'approver' } }
    ]
  },
  // Product
  {
    path: 'product-profile',
    data: { moduleCode: 'prd_prd' },
    children: [
      { path: '', loadComponent: () => import('./product/product').then((m) => m.Product) },
      { path: 'add', loadComponent: () => import('./product/product-details/product-details').then((m) => m.ProductDetails) },
      { path: 'details/:id', loadComponent: () => import('./product/product-details/product-details').then((m) => m.ProductDetails) },
      { path: 'import', loadComponent: () => import('./product/product-import/product-import').then((m) => m.ProductImport) }
    ]
  },
  // Product Details Update
  {
    path: 'product-details-update',
    data: { moduleCode: 'prd_details_update' },
    children: [
      { path: '', loadComponent: () => import('./update-product-req/update-product-req').then((m) => m.UpdateProductReq) },
      {
        path: 'details/:id',
        loadComponent: () => import('./product/product-details/product-details').then((m) => m.ProductDetails),
        data: { reqModuleType: 'approver' }
      }
    ]
  },
  // New Product Creation
  {
    path: 'new-product-creation',
    data: { moduleCode: 'prd_new_creation' },
    children: [
      { path: '', loadComponent: () => import('./new-product-req/new-product-req').then((m) => m.NewProductReq) },
      {
        path: 'details/:id',
        loadComponent: () => import('./product/product-details/product-details').then((m) => m.ProductDetails),
        data: { reqModuleType: 'approver' }
      }
    ]
  },
  // Price Change Profile
  {
    path: 'price-change-profile',
    data: { moduleCode: 'prd_price_change_pro' },
    children: [
      { path: '', loadComponent: () => import('./price-change-profile/price-change-profile').then((m) => m.PriceChangeProfile) },
      {
        path: 'bulk-update-price',
        loadComponent: () => import('./price-change-profile/details/details').then((m) => m.PriceChangeProfileDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./price-change-profile/details/details').then((m) => m.PriceChangeProfileDetails)
      }
    ]
  },
  // Cost Change Profile
  {
    path: 'cost-change-profile',
    data: { moduleCode: 'prd_cost_change_pro' },
    children: [
      { path: '', loadComponent: () => import('./cost-change-profile/cost-change-profile').then((m) => m.CostChangeProfile) },
      {
        path: 'bulk-update-cost',
        loadComponent: () => import('./cost-change-profile/cost-change-details/cost-change-details').then((m) => m.CostChangeDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./cost-change-profile/cost-change-details/cost-change-details').then((m) => m.CostChangeDetails)
      }
    ]
  },
  // Price Logs
  {
    path: 'price-logs',
    data: { moduleCode: 'prd_price_log' },
    children: [{ path: '', loadComponent: () => import('./price-logs/price-logs').then((m) => m.PriceLogs) }]
  },

  // Cost Logs
  {
    path: 'cost-logs',
    data: { moduleCode: 'prd_cost_log' },
    children: [{ path: '', loadComponent: () => import('./cost-logs/cost-logs').then((m) => m.CostLogs) }]
  },

  //product Field Configuration
  {
    path: 'product-field-configuration',
    data: { moduleCode: 'prd_field_config' },
    children: [{ path: '', loadComponent: () => import('./product-field-config/product-field-config').then((m) => m.ProductFieldConfig) }]
  }
];
